import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'checkbox-button',
    templateUrl: './input.checkbox_button.component.html'
})
export class CheckboxButtonComponent implements OnInit {
    /**
     * Label of the checkbox
     */
    @Input() label: string;

    /**
     * Name of the checkbox
     */
    @Input() name: string;

    /**
     * value for the checkbox
     */
    @Input() value: any;

    /**
     * Value if the model is not checked
     * @type {boolean}
     */
    @Input() uncheckedValue: any = false;

    /**
     * Required ore not
     */
    @Input() required: boolean;

    /**
     * the model
     */
    @Input() model: any;

    /**
     * Form for validation
     */
    @Input() form: FormGroup = null;

    /**
     * extra classs for the checkbox
     */
    @Input() class: string = null;

    /**
     * event if the model changes
     * @type {EventEmitter<any>}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param event
     */
    updateModel(event: any) {
        let newValue: string;
        if(event.target.checked === false && this.model !== this.value) {
            // case 1: model was presetted with other values
            newValue = this.value;
        }
        else {
            // case 2: first or followup switch of the checkbox
            newValue = event.target.checked === true? this.value : this.uncheckedValue;
        }
        this.model = newValue;
        this.modelChange.emit(newValue);

        // update validators if we have a form (i.e. for required checkboxes)
        if(this.form) {
            this.form.controls[this.name].setValue(newValue);
            this.form.controls[this.name].updateValueAndValidity();
        }
    }

    ngOnInit() {

    }
}
